import React from 'react'
import LeaveRejoin from '../Components/LeaveManagement/LeaveRejoin/LeaveRejoin'

const LeaveRejoinPage = () => {
  return (
    <div style={{padding:"8px 0px"}} className='NewFormBackColor'>
      <LeaveRejoin/>
    </div>
  )
}

export default LeaveRejoinPage
